<template>
  <section id="article-listing" class="section article-listing h-offset">
    <div class="inner container">
      <tabs @change="selectCategory">
        <tab
          v-for="tab in tabs"
          :name="tab.slug"
          :key="tab.title"
          :selected="category ? category === tab.slug : !tab.slug"
        >
          <template v-slot:button>{{ tab.title }}</template>
          <ul
            class="article-grid"
            data-article-mod="1"
            :class="{ loading }"
            v-if="posts && posts.length"
          >
            <li v-for="post in posts">
              <a
                :href="post.video_url"
                class=""
                v-if="post.video_url"
                target="_blank"
              >
                <div
                  class="image tinted tinted-20"
                  v-if="post.featured_media_urls.medium"
                >
                  <img
                    :src="post.featured_media_urls.medium"
                    class="cover"
                    :alt="post.title"
                  />
                  <div class="video-cta">
                    <button type="button" data-play-video="">
                      <i class="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 365.2 512"
                        >
                          <path d="M3.6 508.4l357.3-252.2L3.6 4z" />
                        </svg>
                      </i>
                      <span class="uc">Watch Video</span>
                    </button>
                  </div>
                </div>
                <div class="inner">
                  <h4 class="wt-md fg-primary">{{ post.title }}</h4>
                  <div class="content lh-tight">
                    {{ post.excerpt }}
                  </div>
                </div>
              </a>
              <a :href="post.url" v-else>
                <div
                  class="image tinted tinted-20"
                  v-if="post.featured_media_urls.medium"
                >
                  <img
                    :src="post.featured_media_urls.medium"
                    class="cover"
                    :alt="post.title"
                  />
                </div>
                <div class="inner">
                  <h4 class="wt-md fg-primary">{{ post.title }}</h4>
                  <div class="content lh-tight">
                    {{ post.excerpt }}
                  </div>
                </div>
              </a>
            </li>
          </ul>
          <div v-else-if="!loading">
            <p>No posts were found</p>
          </div>
        </tab>
      </tabs>
      <div class="cta align-center" v-if="nextPage">
        <a class="button primary ib" @click.prevent="fetch(nextPage)"
          >Load More</a
        >
      </div>
      <loader :loading="loading"></loader>
    </div>
  </section>
</template>
<script>
import isEmpty from "lodash/isEmpty";
import Tabs from "../tabs/Tabs";
import Tab from "../tabs/Tab";
import qs from "qs";

export default {
  components: {
    Tabs,
    Tab,
  },
  props: {
    category: {
      type: String,
      required: false,
    },
    categories: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    this.fetch(1);
  },
  data() {
    return {
      tabs: [
        {
          title: "Discover all",
          slug: null,
        },
      ].concat(this.categories),
      current_category: this.category,
      response: null,
      posts: [],
      loading: false,
      urlSearchParams: new URLSearchParams(
        new URL(window.location.href).search
      ),
    };
  },
  methods: {
    fetch(page) {
      return new Promise(async (resolve, reject) => {
        this.loading = true;
        await axios
          .get("/api/industry-news", {
            params: {
              page: page,
              category: this.current_category,
            },
            paramsSerializer: (params) => qs.stringify(params),
          })
          .then((response) => {
            this.response = response.data;
            if (page === 1) {
              this.posts = this.response.data;
            } else {
              this.posts = this.posts.concat(response.data.data);
            }
            resolve();
          })
          .catch((error) => {
            reject(error);
          })
          .then(() => {
            this.loading = false;
          });
      });
    },
    selectCategory(tab) {
      this.current_category = tab.name;
      this.fetch(1);
    },
    isEmpty(object) {
      return isEmpty(object);
    },
  },
  computed: {
    nextPage() {
      if (
        !this.posts.length ||
        !this.response ||
        this.response.current_page === this.response.last_page
      ) {
        return null;
      }
      return this.response.current_page + 1;
    },
  },
};
</script>
